import { Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';

@Component({
    standalone: false,
    selector: 'res-download-as-pdf-stamp-modal',
    templateUrl: './download-as-pdf-stamp-modal.component.html',
    styleUrls: ['./download-as-pdf-stamp-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DownloadAsPDFStampModalComponent extends BaseModalComponent {

    modalAutomationId = 'download-as-pdf-stamp';
    modalTitle = 'Download as PDF';
    secondaryButtonLabel = 'Cancel';
    modalClass = 'download-as-pdf-stamp-modal';
    stampDocumentNumber = false;

    constructor(private modalService: BsModalService, private modalRef: BsModalRef,) {
        super(modalService, modalRef);
    }

    ok(): void {
        this.closeModal(true, { isStampEnabled: this.stampDocumentNumber });
    }

}
